import React from "react";

function OrderBySelect({ value, onChange }) {
  const handleChange = (event) => {
    const inputValue = event.target.value;
    onChange(inputValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="orderBySelect" className="form-label">
        Order By
      </label>
      <select className="form-select" id="orderBySelect" value={value} onChange={handleChange}>
        <option value="distance_asc">Distance Ascending</option>
        <option value="model_timestamp_asc">Model Timestamp Ascending</option>
        <option value="model_timestamp_desc">Model Timestamp Descending</option>
      </select>
    </div>
  );
}

export default OrderBySelect;
